'use client';

import { usePathname } from 'next/navigation';
import { ButtonHTMLAttributes, useEffect, useRef, useState } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

function Hamburger({ onClick, ...rest }: Props) {
  const pathname = usePathname();
  const [expanded, setExpanded] = useState(false);
  const [renderedPath, setRenderedPath] = useState(pathname);
  const buttonRef = useRef<HTMLButtonElement>(null);

  if (pathname !== renderedPath) {
    setRenderedPath(pathname);
    setExpanded(false);
  }

  useEffect(() => {
    if (!expanded) return;

    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;
      setExpanded(false);
      buttonRef.current?.focus();
    };

    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [expanded]);

  return (
    <button
      type='button'
      className='hamburger'
      {...rest}
      aria-expanded={expanded}
      onClick={event => {
        onClick?.(event);
        setExpanded(current => !current);
      }}
      ref={buttonRef}
    >
      <span />
    </button>
  );
}

export default Hamburger;
